import { observer } from 'mobx-react-lite';
import { motion, AnimatePresence } from 'framer-motion';
import { useStore } from '@/app/StoreContext';
import { trophyIn } from '@/styles/motion';
import { humanizeReason } from '@/domain/rejectReason';
import { HiWord } from './HiWord';
import styles from './WordsList.module.css';

export const WordsList = observer(function WordsList() {
  const { round } = useStore();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.headerLabel}>Мои слова ({round.myWords.length})</span>
        <span className={styles.headerScore}>{round.myTotalScore}</span>
      </div>
      {round.myWords.length === 0 ? (
        <div className={styles.emptyCard}>
          {round.letters && (
            <div className={styles.emptyLetters}>
              {round.letters.map((l, i) => (
                <span key={i} className={styles.emptyLetter}>{l.toUpperCase()}</span>
              ))}
            </div>
          )}
          <p className={styles.emptyTitle}>Пока ни одного слова</p>
          <p className={styles.emptyHint}>Найди существительное с этими буквами</p>
        </div>
      ) : (
        <ul className={styles.list}>
          <AnimatePresence initial={false}>
            {round.myWords.map(w => (
              <motion.li
                key={w.submittedAt + w.word}
                variants={trophyIn}
                initial="hidden"
                animate="visible"
                exit={{ opacity: 0 }}
                className={styles.item}
              >
                <HiWord word={w.word} letters={round.letters ?? undefined} />
                <span className={styles.score}>+{w.rawScore}</span>
              </motion.li>
            ))}
          </AnimatePresence>
        </ul>
      )}
      {round.myRejections.length > 0 && (
        <ul className={styles.rejections}>
          {round.myRejections.map(r => (
            <li key={r.rejectedAt + r.word} className={styles.rejected}>
              <s>{r.word}</s> · {humanizeReason(r.reason)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});
